// Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import { useUIContext } from "../../contexts/UIContext";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Backdrop from "./Backdrop";
import Modal from "./Modal";

const Layout = () => {
  const {
    isSidebarOpen,
    isModalOpen,
    isBackdropVisible,
    modalContent,
    toggleSidebar,
    closeModal,
    closeSidebar,
  } = useUIContext();

  return (
    <div className="flex flex-col min-h-screen relative">
      {isSidebarOpen && <Sidebar />}
      <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
      <div className="flex-1 flex flex-col">
        <Header toggleSidebar={toggleSidebar} />
        {/* <main className="flex-1 md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto"> */}
        {/* <main className="mt-10 md:mt-0 flex-1 pt-[80px] lg:pt-[88px] md:pt-[120px]  sm:pt-[144px] md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto"> */}
        <main className="mt-10 md:mt-0 flex-1 pt-[80px] lg:pt-[88px] md:pt-[120px]  sm:pt-[144px] md:p-4 sm:py-4 bg-white  ">
          <Outlet />
        </main>
        <Footer />
      </div>
      <Modal isVisible={isModalOpen} onClose={closeModal}>
        {modalContent} {/* Render dynamic modal content */}
      </Modal>
    </div>
  );
};

export default Layout;

// // Layout.js
// import React from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import { useUIContext } from "../../contexts/UIContext";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import Backdrop from "./Backdrop";
// import Modal from "./Modal";
// import { hideSidebarPaths } from "../../constants/hideComponentPaths";
// import { match } from "path-to-regexp";

// const Layout = () => {
//   const {
//     isSidebarOpen,
//     isModalOpen,
//     isBackdropVisible,
//     modalContent,
//     toggleSidebar,
//     closeModal,
//     closeSidebar,
//   } = useUIContext();

//   const location = useLocation();

//   const shouldHideSidebar = () =>
//     hideSidebarPaths.some((pattern) => {
//       const matcher = match(pattern, { decode: decodeURIComponent });
//       return matcher(location.pathname) !== false;
//     });

//   const showSidebar = isSidebarOpen && !shouldHideSidebar();

//   return (
//     <div className="flex flex-col min-h-screen relative">
//       {showSidebar && <Sidebar />}
//       <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
//       <div className="flex-1 flex flex-col">
//         <Header toggleSidebar={toggleSidebar} />
//         <main className="flex-1 md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto">
//           <Outlet />
//         </main>
//       </div>
//       <Modal isVisible={isModalOpen} onClose={closeModal}>
//         {modalContent}
//       </Modal>
//     </div>
//   );
// };

// export default Layout;

// LAYOUT BEFORE MODAL IMPLEMENTATION - HEADER & SIDEBAR WORKING
// // Layout.js
// import React from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import { useUIContext } from "../../contexts/UIContext";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import Backdrop from "./Backdrop";
// import Modal from "./Modal";
// import { hideSidebarPaths } from "../../constants/hideComponentPaths";
// import { match } from "path-to-regexp";

// const Layout = () => {
//   const {
//     isSidebarOpen,
//     isModalOpen,
//     isBackdropVisible,
//     toggleSidebar,
//     closeModal,
//     closeSidebar,
//   } = useUIContext();

//   const location = useLocation();

//   // Determine if the sidebar should be hidden for certain paths
//   const shouldHideSidebar = () =>
//     hideSidebarPaths.some((pattern) => {
//       const matcher = match(pattern, { decode: decodeURIComponent });
//       return matcher(location.pathname) !== false;
//     });

//   // Show the sidebar only if it is toggled open and not on hidden paths
//   const showSidebar = isSidebarOpen && !shouldHideSidebar();

//   return (
//     <div className="flex flex-col min-h-screen relative">
//       {/* Sidebar */}
//       {showSidebar && <Sidebar />}
//       {/* Backdrop */}
//       <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         <Header toggleSidebar={toggleSidebar} />
//         <main className="flex-1 md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto">
//           <Outlet />
//         </main>
//       </div>
//       {/* Modal */}
//       <Modal isVisible={isModalOpen} onClose={closeModal}></Modal>
//     </div>
//   );
// };

// export default Layout;

// // Layout.js
// import React from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import { useUIContext } from "../../contexts/UIContext";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import Backdrop from "./Backdrop";
// import Modal from "./Modal";
// import { hideSidebarPaths } from "../../constants/hideComponentPaths";
// import { match } from "path-to-regexp";

// const Layout = () => {
//   const {
//     isSidebarOpen,
//     isModalOpen,
//     isBackdropVisible,
//     toggleSidebar,
//     closeModal,
//     closeSidebar,
//   } = useUIContext();

//   const location = useLocation();

//   // Determine if the sidebar should be hidden for certain paths
//   const shouldHideSidebar = () =>
//     hideSidebarPaths.some((pattern) => {
//       const matcher = match(pattern, { decode: decodeURIComponent });
//       return matcher(location.pathname) !== false;
//     });

//   const showSidebar = !shouldHideSidebar();

//   return (
//     <div className="flex flex-col min-h-screen relative">
//       {showSidebar && <Sidebar />}
//       <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
//       <div className="flex-1 flex flex-col">
//         <Header toggleSidebar={toggleSidebar} />
//         <main className="flex-1 md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto">
//           <Outlet />
//         </main>
//       </div>
//       <Modal isVisible={isModalOpen} onClose={closeModal}></Modal>
//     </div>
//   );
// };

// export default Layout;

// LAYOUT BEFORE UI CONTEXT
// import React, { useState } from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import Backdrop from "./Backdrop";
// import Modal from "./Modal";
// import { hideSidebarPaths } from "../../constants/hideComponentPaths";
// import { match } from "path-to-regexp";

// const Layout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isBackdropVisible, setIsBackdropVisible] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const location = useLocation();

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//     setIsBackdropVisible(!isSidebarOpen || isModalOpen);
//   };

//   const openModal = () => {
//     setIsModalOpen(true);
//     setIsBackdropVisible(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsBackdropVisible(isSidebarOpen);
//   };

//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//     setIsBackdropVisible(isModalOpen);
//   };

//   // Function to check if the sidebar should be hidden based on path
//   const shouldHideSidebar = () => {
//     return hideSidebarPaths.some((pattern) => {
//       const matcher = match(pattern, { decode: decodeURIComponent });
//       return matcher(location.pathname) !== false;
//     });
//   };

//   const showSidebar = !shouldHideSidebar();

//   return (
//     <div className="flex flex-col min-h-screen relative">
//       {showSidebar && (
//         <Sidebar
//           isOpen={isSidebarOpen}
//           toggleSidebar={toggleSidebar}
//           closeSidebar={closeSidebar}
//         />
//       )}
//       <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
//       <div className="flex-1 flex flex-col">
//         <Header toggleSidebar={toggleSidebar} />
//         <main className="flex-1 md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto">
//           <Outlet />
//         </main>
//       </div>
//       <Modal isVisible={isModalOpen} onClose={closeModal}></Modal>
//     </div>
//   );
// };

// export default Layout;
// ===========================================================================================
// import React, { useState } from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import Backdrop from "./Backdrop";
// import Modal from "./Modal";
// import { hideSidebarPaths } from "../../constants/hideComponentPaths";

// const Layout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isBackdropVisible, setIsBackdropVisible] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const location = useLocation();
//   // const hideSidebarPaths = ["/signin", "/signup", "/"];

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//     setIsBackdropVisible(!isSidebarOpen || isModalOpen);
//   };

//   const openModal = () => {
//     setIsModalOpen(true);
//     setIsBackdropVisible(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsBackdropVisible(isSidebarOpen);
//   };

//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//     setIsBackdropVisible(isModalOpen);
//   };

//   const showSidebar = !hideSidebarPaths.includes(location.pathname);

//   return (
//     <div className="flex flex-col min-h-screen relative">
//       {showSidebar && (
//         <Sidebar
//           isOpen={isSidebarOpen}
//           toggleSidebar={toggleSidebar}
//           closeSidebar={closeSidebar}
//         />
//       )}
//       <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
//       {/* <div className="flex-1 flex flex-col lg:ml-64"> */}
//       <div className="flex-1 flex flex-col">
//         <Header toggleSidebar={toggleSidebar} />
//         <main className="flex-1 md:p-4 sm:py-4 bg-white border-2 border-agBorder overflow-y-auto">
//           <Outlet />
//         </main>
//       </div>
//       <Modal isVisible={isModalOpen} onClose={closeModal}></Modal>
//     </div>
//   );
// };

// export default Layout;
// // ========================================================================================================================

// // import React, { useState } from "react";
// // import { Outlet, useLocation } from "react-router-dom";
// // import Header from "./Header";
// // import Sidebar from "./Sidebar";
// // import Backdrop from "./Backdrop";
// // import Modal from "./Modal";

// // // List of paths where the sidebar and header should be hidden
// // const hideSidebarPaths = ["/signin", "/signup", "/welcome"];
// // const hideHeaderPaths = ["/checkout", "/login"]; // Update based on your requirements

// // const Layout = () => {
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isBackdropVisible, setIsBackdropVisible] = useState(false);
// //   const [isModalOpen, setIsModalOpen] = useState(false);

// //   const location = useLocation();

// //   const toggleSidebar = () => {
// //     setIsSidebarOpen(!isSidebarOpen);
// //     setIsBackdropVisible(!isSidebarOpen || isModalOpen);
// //   };

// //   const openModal = () => {
// //     setIsModalOpen(true);
// //     setIsBackdropVisible(true);
// //   };

// //   const closeModal = () => {
// //     setIsModalOpen(false);
// //     setIsBackdropVisible(isSidebarOpen);
// //   };

// //   const closeSidebar = () => {
// //     setIsSidebarOpen(false);
// //     setIsBackdropVisible(isModalOpen);
// //   };

// //   // Check if the current path requires hiding the sidebar and header
// //   const showSidebar = !hideSidebarPaths.includes(location.pathname);
// //   const showHeader = !hideHeaderPaths.includes(location.pathname);

// //   return (
// //     <div className="flex flex-col min-h-screen relative">
// //       {showSidebar && (
// //         <Sidebar
// //           isOpen={isSidebarOpen}
// //           toggleSidebar={toggleSidebar}
// //           closeSidebar={closeSidebar}
// //         />
// //       )}
// //       <Backdrop isVisible={isBackdropVisible} onClick={closeSidebar} />
// //       <div className="flex-1 flex flex-col">
// //         {showHeader && <Header toggleSidebar={toggleSidebar} />}
// //         <main className="flex-1 md:p-4 sm:py-4 bg-agBg border-2 border-agBorder overflow-y-auto">
// //           <Outlet />
// //         </main>
// //       </div>
// //       <Modal isVisible={isModalOpen} onClose={closeModal}></Modal>
// //     </div>
// //   );
// // };

// // export default Layout;
